import { createSlice } from "@reduxjs/toolkit";
import club_img_1 from "assets/images/club-img-1.png";
import batting_logo from "assets/images/batting-logo.png";
import player1 from "assets/images/player-1.png";
import player2 from "assets/images/player-2.png";
import player3 from "assets/images/player-3.png";
import player4 from "assets/images/player-4.png";
import country_logo from "assets/images/country-logo.png";

const initialState = {
  data: [
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Kieron Pollard",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player1,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Shane Watson",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player2,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "AB De Villirs",
      country: "Batsman | Right Handed",
      countryLogo: country_logo,
      logo: player3,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
    {
      name: "Andre Russell",
      country: "All Rounder",
      countryLogo: country_logo,
      logo: player4,
      playerHistoryTitle: ["Mat", "100S", "50S", "6S", "4S"],
      playerHistory: [39, 2, 4, 49, 41],
    },
  ],
  battingForm: [
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: true,
    },
    {
      teamName: "Blaster ",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "11(5)",
      outType: "-",
      onStrike: true,
    },
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: false,
    },
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: false,
    },
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: false,
    },
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: false,
    },
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: false,
    },
    {
      teamName: "V Stars",
      opponentTeamName: " Challenger",
      date: "2021-06-15",
      score: "14(8)",
      outType: "-",
      onStrike: false,
    },
  ],
};

export const PlayersDetails = createSlice({
  name: "relatedMatchData",
  initialState,
});

export default PlayersDetails.reducer;
